export default __webpack_public_path__ + "static/eraf_en-a08347d32a1a1e5244e92ce67515f603.svg";